import { Service } from '@angular/core';
import { Subject } from 'rxjs';

export interface Message {
  type: 'info' | 'success' | 'error';
  message: string;
}

@Service()
export class ToastService {
  public messages = new Subject<Message>();

  pushMessage(type: 'info' | 'success' | 'error', message: string) {
    this.messages.next({ type, message });
  }

  info(message: string) {
    this.pushMessage('info', message);
  }

  success(message: string) {
    this.pushMessage('success', message);
  }

  error(message: string) {
    this.pushMessage('error', message);
  }
}
